module.exports = __webpack_public_path__ + "assets/icomoon.9f4eda05.eot";